import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { BUSINESS } from '@core/constants';
import { NetworkService } from '@core/services';
import { environment } from '@environments/environment';
import { version } from '../../../../../package.json';

const ENV_LABELS: Record<string, string> = {
  local: 'Local',
  development: 'Desarrollo',
};

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private readonly networkService = inject(NetworkService);

  public currentYear = new Date().getFullYear();
  readonly business = BUSINESS;

  readonly appVersion = version;
  readonly envName = environment.envName;
  readonly envLabel = ENV_LABELS[environment.envName] ?? null;

  readonly isOnline = this.networkService.isOnline;
}
